<script setup>
  import AppSidebar from "@/components/App/Sidebar/AppSidebar.vue";
  import { computed, ref } from "vue";
  import { Settings, LayoutTemplate, BarChart3 } from "lucide-vue-next";
  import { useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { useCurrentUserStore } from "@stores/currentUser.js";
  import { useMasterReportsStore } from "@stores/masterReports/masterReports";

  const { canWriteSurveys } = storeToRefs(useCurrentUserStore());
  const masterReportsStore = useMasterReportsStore();
  const { currentMasterReport } = storeToRefs(masterReportsStore);

  const token = computed(() => currentMasterReport.value?.token);

  const route = useRoute();

  const hasEditRole = computed(() => canWriteSurveys.value);

  const navigation = computed(() => [
    {
      title: "Configure",
      isOpen: ref(true),
      items: [
        {
          title: "Setup",
          url: `/master-reports/${token.value}/setup`,
          icon: Settings,
          isActive: !!route.path.match(/^\/master-reports\/(.*)\/setup/),
          if: hasEditRole,
        },
        {
          title: "Slide Templates",
          url: `/master-reports/${token.value}/slides`,
          icon: LayoutTemplate,
          isActive: !!route.path.match(/^\/master-reports\/(.*)\/slides/),
          if: hasEditRole,
        },
        {
          title: "Chart Templates",
          url: `/master-reports/${token.value}/charts`,
          icon: BarChart3,
          isActive: !!route.path.match(/^\/master-reports\/(.*)\/charts/),
          if: hasEditRole,
        },
      ],
    },
  ]);
</script>

<template>
  <AppSidebar
    :navigation="navigation"
    :back="{ label: 'Master reports', to: '/master-reports' }" />
</template>
